import React, { forwardRef, useEffect } from "react";
import { CheckCircle } from "lucide-react";
import "flatpickr/dist/flatpickr.css";

type Props = {
  onCloseModal?: () => void;
};

const Completed = forwardRef(({ onCloseModal }: Props, ref) => {

  useEffect(() => {
    if (ref) {
      // @ts-ignore
      ref.current = {
        submitForm: () => {
          onCloseModal?.();
        },
      };
    }
  }, [ref, onCloseModal]);

  return (
    <div className="px-4 py-6 mx-auto text-center lg:w-2/3">
      <CheckCircle className="block size-10 mx-auto mb-4 text-green-500 fill-green-100 dark:fill-green-500/20 animate-icons" />
      <h5 className="mb-2">Solicitud creada con éxito</h5>
      <p className="mb-5 text-slate-500 text-15">
        Nos complace informarle que su registro se ha procesado correctamente.
      </p>
    </div>
  );
});

export default Completed;
